// extracted by mini-css-extract-plugin
export default {"containerSearchBar":"SearchBar_containerSearchBar__2n+Fa","searchBar":"SearchBar_searchBar__rXsj5"};